import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "healingFilled"
const HealingFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.148 15.58C21.514 15.946 21.514 16.54 21.148 16.906L17.436 20.618C17.07 20.984 16.476 20.984 16.11 20.618L12.795 17.303 17.833 12.264z" />
          <path
            fillRule="evenodd"
            d="M15.89 2.646C16.115 2.555 16.37 2.555 16.596 2.646 16.708 2.692 16.815 2.761 16.906 2.852L20.618 6.564C20.984 6.93 20.984 7.524 20.618 7.89L7.89 20.618C7.661 20.847 7.343 20.932 7.048 20.875Q7.003 20.866 6.96 20.854C6.816 20.81 6.679 20.732 6.564 20.618L2.852 16.906Q2.818 16.872 2.788 16.834C2.508 16.491 2.508 15.994 2.788 15.651Q2.818 15.614 2.852 15.58L15.58 2.852Q15.719 2.715 15.89 2.646M10.41 14.121 11.47 15.181 12.53 14.122 11.47 13.061zM8.288 12.001 9.349 13.06 10.409 12 9.35 10.94zM12.53 12 13.59 13.06 14.651 12 13.592 10.94zM10.409 9.878 11.47 10.939 12.53 9.88 11.47 8.819z"
            clipRule="evenodd"
          />
          <path d="M7.095 2.852C7.46 2.486 8.055 2.486 8.42 2.852L11.204 5.636 6.167 10.674 3.383 7.89C3.017 7.524 3.017 6.93 3.383 6.564z" />
        </svg>
      }
    </span>
  )
}
export default HealingFilledIcon
